export const registrationTrackingIds = {
  loginForm: {
    loginButton: 'registration--loginForm-login-button',
    googleButton: 'registration--loginForm-google-button',
    githubButton: 'registration--loginForm-github-button',
    doButton: 'registration--loginForm-do-button',
    forgotPasswordLink: 'registration--loginForm-forgot-password-link',
    loginDifferentAccount: 'registration--loginFormlogin-different-account',
    forgetPreferredSignIn: 'registration--loginForm-forget-preferred-sign-in',
  },
  registrationForm: {
    googleButton: 'registration--registrationForm-google-button',
    githubButton: 'registration--registrationForm-github-button',
    emailButton: 'registration--registrationForm-email-button',
    inlineGoogleButton: 'registration--registrationForm-inline-google-button',
    inlineGithubButton: 'registration--registrationForm-inline-github-button',
    signUpButton: 'registration--registrationForm-sign-up-button',
  },
  header: {
    logoButton: 'registration--header-logo-button',
    signupButton: 'registration--header-signup-button',
  },
  termsOfService: 'registration--terms-of-service',
  privacyPolicy: 'registration--privacy-policy',
};
